require("./bootstrap");

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

import "~/plugins";
import "~/components";
import "~/mixins";

import "./assets/styles/index.css";

Vue.config.productionTip = process.env.NODE_ENV === "production";

Sentry.init({
  Vue,
  dsn: "https://b7715e2cbf9f40db8b4e62709f38fe06@o214976.ingest.sentry.io/6302714",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "app.koehlerinstrument.interconnecta.dev", /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
